<template>
  <layout-component>
    <div class="banner banner-blog">
      <div class="container">
        <div class="row d-md-flex justify-content-md-center">
          <div class="col-md-8">
            <h1 class="left-bullet">{{'w.blog.title-banner'|t}}</h1>
          </div>
          </div>


      </div>
    </div>
    <div class="container">
        <div class="row">
          <div v-for="post in blogposts" class="col-md-6" :key="post.id">
            <div class="card-blog">
              <router-link :to="'/blog/post/'+post.id">
              <div class="img-wrapper">
                <div class="noise">
                  <img class="img-fluid"  v-if="post.image" :src="'/storage/'+post.image" loading="lazy" :alt="$i18n.locale == 'fr' ? post.title : post.title_en" />
                </div>
              </div>
              <div class="text-wrapper">
                <div class="date bottom-cut">{{ post.date | formatDateBlog }}</div>
                <h3>{{ $i18n.locale == 'fr' ? post.title : post.title_en }}</h3>
                <p class="btn-link">{{'w.blog.card-btn'|t}}</p>
              </div>
              </router-link>
            </div>
          </div>
        </div>
    </div>
  </layout-component>
</template>

<script>
    export default {
      data() {
        return {
            blogposts:null,
        }
      },
      methods: {
        setData(data) {
          // /blog renvoie désormais une réponse PAGINÉE ({data:[...]}) après l'upgrade
          // backend → on extrait le tableau (sinon v-for itère l'objet pagination = crash).
          this.blogposts = Array.isArray(data) ? data : (data && data.data) || []
        }
      },
      beforeRouteEnter(to, from, next) {
        Vue.axios.get('/blog').then( ({data}) => {
          next(vm => vm.setData(data))
        }).catch(() => next()); // l'API échoue → on n'empêche pas la navigation (sinon route bloquée)
      }
    }
</script>
